
import { sortData } from "oolib";
import { queryClient } from "../../index";
import {__GetAllContentTypeConfig} from '../../utils/getters/gettersV2'
import { __GetAccessibleContentTypes, __GetAccessibleContentTypesForTheUser } from "../../utils/accessControl";
import { extractAllBlocksFromTpl } from "@/utils/templating/extractAllBlocksFromTpl";
import { getRollupPossibilities } from "@/components/analysisModules/AnnotationExplorer/utils/autoGenFilterConfigsFromTpl";

export const additionalOptionsFns = {
  getTagTypes: () => {
    let wordTags = queryClient
      .getQueryData("platformConfigs")
      ._TagTypes.map((d) => ({ display: d.tagType, value: d.tagType }));
    wordTags = sortData({
      data: wordTags,
      path: "value",
      fn: "alphabetical",
    });
    let userTags = queryClient
      .getQueryData("platformConfigs")
      ._ProfileTypes.map((d) => ({
        display: "💁🏽‍♂️ " + d.content.title,
        value: d.id,
      }));
    let contentTags = __GetAllContentTypeConfig().map((d) => ({
      display: d.general?.content?.title,
      value: d.kp_content_type,
    }));
    return [...wordTags, ...userTags, ...contentTags];
  },
  getWordTagTypes: () => {
    return queryClient
      .getQueryData("platformConfigs")
      ._TagTypes.map((d) => ({ display: d.tagType, value: d.tagType }));
  },
  getContentTypes: () => {
    return __GetAllContentTypeConfig().map((d) => ({
      display: d.general?.content?.title || d.id,
      value: d.kp_content_type,
    }));
  },
  getValuePathsFromTpls: (args) => { //fully unused right now... but leaving it... in case its handy in the future...
    const tpl = queryClient.getQueryData(['tpl', args?.contentType]);
    const allBlocks = tpl ? extractAllBlocksFromTpl({tpl}) : [];
    if(!args?.blockFilter) {
      const toReturn = allBlocks.map(bl => {
        //we have this map because these components with fixed valuepaths, dont have the possibility of a 'label' of any kind
        const fixedBlockValuePathsMap = {
          'main.title': 'Title', 
          'main.subtitle': 'Subtitle', 
          'main.coverImage': 'Cover Image', 
          'main.coverVideo': 'Cover Video'
        };
        if(Object.keys(fixedBlockValuePathsMap).includes(bl.valuePath)){
          return ({
            display: fixedBlockValuePathsMap[bl.valuePath],
            value: bl.valuePath
          })
        }
        return ({display: bl.props.shortLabel || bl.props.label || bl.valuePath, value: bl.valuePath})
      });
      return toReturn;
    }
  },
  getFieldsCompatibleWithAggrMetricsAcrossDimensions: ({contentType}) => {

    if(!contentType) return [];
    const allTpls = queryClient.getQueryData('allTpls');

    const thisCTTpl = allTpls.find(tpl => tpl.kp_content_type === contentType);
    const thisCTBlocks =  extractAllBlocksFromTpl({tpl: thisCTTpl})
    const thisCTTagBlocks = thisCTBlocks.filter(bl => bl.valuePath.startsWith("tags."));
    const thisCTOptionSelectBlocks = thisCTBlocks.filter(bl => bl.props.options && Array.isArray(bl.props.options) && bl.props.options?.length > 0 )
    
    const normalOptionsToReturn = [...thisCTTagBlocks, ...thisCTOptionSelectBlocks].map(d => ({
      display: d.props.shortLabel || d.props.label || d.valuePath,
      value: d.valuePath
    }))

    let allRollupPossibilities = [];
    for(const tagBlock of thisCTTagBlocks){
      const thisRollupPossibilities = getRollupPossibilities({tagType: tagBlock.props.tagType, allTpls});
      allRollupPossibilities = [
        ...allRollupPossibilities,
        ...thisRollupPossibilities
      ]     
    }

    const rollupOptionsToReturn = allRollupPossibilities.map(op => {
      const thisRolledupTagTpl = allTpls.find(tpl => tpl.kp_content_type === op.tagTypeCollectionToRollup );
      const blocksOf_thisRolledupTagTpl = extractAllBlocksFromTpl({tpl: thisRolledupTagTpl});
      if(op.rollupType === 'valuePathType'){
        const blockConfigOfRollupValuePath = blocksOf_thisRolledupTagTpl.find(bl => bl.valuePath === op.blockValuePath);
        return ({
          ...op,
          display: blockConfigOfRollupValuePath?.props.shortLabel || blockConfigOfRollupValuePath?.props.label || blockConfigOfRollupValuePath,
          desc: `of ${thisRolledupTagTpl?.general.content.title}`,
          value: op.tagTypeCollectionToRollup + '__' +op.blockValuePath,
        })
      }else if(op.rollupType === 'tagType'){
        const finalTagTypeThatIsRolledUp = op.rollupPath[op.rollupPath.length-1];
        
        return ({
          ...op,
          display: allTpls.find(tpl => tpl.kp_content_type === finalTagTypeThatIsRolledUp)?.general?.content?.title || finalTagTypeThatIsRolledUp,
          desc: `of ${thisRolledupTagTpl?.general.content.title}`,
          value: op.rollupPath.join('__')
        })
      }
    })

    return [
      ...normalOptionsToReturn,
      ...rollupOptionsToReturn
    ]
  },
  getContentTypeByAction: ({action}) => {
    const { data: userData } = queryClient.getQueryState("userData");
    return __GetAccessibleContentTypesForTheUser({
      user: userData.user,
      ACTION: action,
    }).map((d) => ({
      display: d.general?.content?.title || d.id,
      value: d.kp_content_type,
    }));
  },
  getProfileTypes: () => {
    return queryClient
      .getQueryData("platformConfigs")
      ._ProfileTypes.map((d) => ({
        display: d.content?.title || d.id,
        value: d.id,
      }));
  },
  getContentStatus: () => [
    { display: "Published", value: "published" },
    { display: "Draft", value: "draft" },
    { display: "Awaiting Review", value: "awaitingModeration" },
    { display: "Under Review", value: "underModeration" },
    { display: "Sent Back", value: "sentBack" },
    { display: "Under Edit", value: "editPublished" },
  ],
};
